export default __webpack_public_path__ + "clientapp/media/robot-06.dca98022.png";